<template>
  <div>
    <Top></Top>
    <!-- start -->
    <div class="topBox"></div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild = toBreadChild></Bread> -->
    <!-- 面包屑 end -->
    <!-- bottomContent start -->
    <div class="content">
      <div class="floatBox">
        <div class="floatLeft">最新消息</div>
        <div class="floatRight">
          <el-select v-model="value" placeholder="全部" @change="changSearch">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="bottomLine"></div>
      <div class="bottomFloat" @click="toLink(inforArrayFirst[0].url)">
        <div class="bottomLeft">
          <img :src="inforImgLeft" alt />
        </div>
        <div class="bottomRight" v-for="(item, index) in inforArrayFirst">
          <div class="rightFlex">
            <div class="rightBox rightBoxLeft">{{ item.textTwo }}</div>
            <div class="rightBox rightBoxRight textRight">{{ item.date }}</div>
          </div>
          <div class="rightText">{{ item.textValue }}</div>
        </div>
      </div>
      <!-- start -->
      <div class="boxContent">
        <div v-for="(item, index) in tempArray">
          <div class="contentList">
            <div class="listBox textCssLeft" @click="toLink(item.url)">
              · {{ item.textTwo }}
            </div>
            <div class="listBox textRightCss textCssRight">{{ item.date }}</div>
          </div>
          <div
            v-if="index == 4 || index == 9 || index == 14"
            class="listLineCss"
          ></div>
        </div>
        <div class="pressCss">
          <el-pagination
            background
            layout="prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10]"
            :page-size="pageSize"
            :total="inforArray.length"
          ></el-pagination>
        </div>
      </div>
      <!-- end -->
      <!-- start -->
      <!-- <div v-for="(item,index) in inforArray.slice(0,5)">
          <div class="contentList">
            <div class="listBox textCssLeft">· {{item.textTwo}}</div>
            <div class="listBox textRightCss textCssRight">{{item.date}}</div>
          </div>
          <div v-if='index == 4' class="listLineCss"></div>
      </div>
      <div v-for="(item,index) in inforArray.slice(5,10)">
          <div class="contentList">
            <div class="listBox textCssLeft">· {{item.textTwo}}</div>
            <div class="listBox textRightCss textCssRight">{{item.date}}</div>
          </div>
          <div v-if='index == 4' class="listLineCss"></div>
      </div>
       <div v-for="(item,index) in inforArray.slice(10,15)">
          <div class="contentList">
            <div class="listBox textCssLeft">· {{item.textTwo}}</div>
            <div class="listBox textRightCss textCssRight">{{item.date}}</div>
          </div>
          <div v-if='index == 4' class="listLineCss"></div>
      </div>-->
      <!-- end -->
    </div>

    <!-- bottomContent end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import inforImgLeft from "@/assets/images/inforImgLeft.jpg";
import Bread from "@/components/bread.vue";
import { constants } from "fs";

export default {
  name: "Information",
  components: {
    Top,
    Footer,
    Bread,
  },
  data() {
    return {
      
      currentPage: 1,
      pageSize: 15,
      inforArray2019: [],
      inforArray2020: [],
      currentTotal: 0,
      toBreadChild: ["咨讯"],
      inforImgLeft: inforImgLeft,
      options: [
         {
          value: "2021",
          label: "2021"
        },
        {
          value: "2020",
          label: "2020",
        },
        {
          value: "2019",
          label: "2019",
        },
      ],
      value: "",
      inforArrayFirst: [
        {
          textTwo: "超级鸡车 | 知名连锁炸鸡店的数字化升级",
          date: "2021-02-26",
          textValue: `超级鸡车 | 知名连锁炸鸡店的数字化升级`,
          url: "https://mp.weixin.qq.com/s/8s_v5r4TEC3lPIbqyEBayg",
        },
      ],
      inforArray: [
        //  {
        //   textTwo: "超级鸡车 | 知名连锁炸鸡店的数字化升级",
        //   date: "2021-02-26",
        //   url: "https://mp.weixin.qq.com/s/8s_v5r4TEC3lPIbqyEBayg",
        // },
        {
          textTwo: "2020年度总结 | 案例盘点",
          date: "2021-01-29",
          url: "https://mp.weixin.qq.com/s/4XYbRxpMj3EaWwLMIDbzcg",
        },
        {
          textTwo: "1月数拓快讯 | 老乡鸡、钱大妈、船歌鱼水饺、缤果鲜茶...多个项目落地",
          date: "2021-01-22",
          url: "https://mp.weixin.qq.com/s/NR2uoqkQpXDJVPkzW-iHMw",
        },
        {
          textTwo: "小龙坎 | 知名连锁火锅品牌的新升级",
          date: "2021-01-15",
          url: "https://mp.weixin.qq.com/s/IEPC5kjiHJbO58yBcYwWjQ",
        },
        {
          textTwo: "达味坊 | 美食广场的数字化升级",
          date: "2021-01-08",
          url: "https://mp.weixin.qq.com/s/3LGhay5lFsyRqEaM6fHi9Q"
        },
        {
          textTwo:
            "12月数拓快讯 | 茶颜悦色、茶百道、夸父、万象影城、另茶...多个项目落地",
          date: "2020-12-25",
          url: "https://mp.weixin.qq.com/s/IuNerACakudzB0Uc-s3NKQ",
        },
        {
          textTwo: "餐牌兼容叫号，低预算、中小体量门店叫号首选！",
          date: "2020-12-11",
          url: "https://mp.weixin.qq.com/s/wKD1UTSW4TYxdnAQ6-5Sbw",
        },
        {
          textTwo: "新瑞鹏宠物医疗集团 | 以关怀宠物为本的智慧门店升级",
          date: "2020-12-04",
          url: "https://mp.weixin.qq.com/s/_mD9LWH7_EEZNSd3Ybe7Ow",
        },
        // ----------------------------------------------------------
        {
          textTwo:
            "11月数拓快讯 | 池奈、超岛串串火锅、原来宝鸡、TipTop...多个项目落地",
          date: "2020-11-20",
          url: "https://mp.weixin.qq.com/s/G8GsWuCw4RB0cSB55v38ug",
        },
        {
          textTwo: "小芳茶卖部 | 洛阳新进网红的“靓店”之选",
          date: "2020-11-14",
          url: "https://mp.weixin.qq.com/s/slwUv9nX0iHylJYP712aSA",
        },
        // ===========
        {
          textTwo: "乔得一茶 | “连锁+加盟”模式下的数字化升级选择",
          date: "2020-10-16",
          url: "https://mp.weixin.qq.com/s/5MYGFF5Zvgbk2p-b-Xha8w",
        },
        {
          textTwo: "莱得快 | 网红景点门店的数字化升级",
          date: "2020-09-25",
          url: "https://mp.weixin.qq.com/s/M2ucZKklgXA1X2HrX-Ytgg",
        },
        {
          textTwo: "跨界营销 | 海底捞 X 三国志战略版，当火锅遇上游戏...",
          date: "2020-09-24",
          url: "https://mp.weixin.qq.com/s/L0muvratT_JjOrDi99jwJQ",
        },
        {
          textTwo:
            "9月数拓快讯 | 三郎米线、船歌鱼水饺、都市甜心、万达影城...多个项目落地",
          date: "2020-09-18",
          url: "https://mp.weixin.qq.com/s/1gZTefH2YU7tWr_XmOIsRg",
        },
        {
          textTwo: "小岳岳代言，老乡鸡全国战略布局要来了！",
          date: "2020-09-04",
          url: "https://mp.weixin.qq.com/s/vHgAWolhKwio5IFRV05--Q",
        },
        {
          textTwo:
            "8月数拓快讯 | 万达影院、一只酸奶牛、豆吉汤圆、贡茶...多个项目落地",
          date: "2020-08-22",
          url: "https://mp.weixin.qq.com/s/y_JJpqgMZbwmi1LiM98thg",
        },
        {
          textTwo: "中智药业 | 老牌上市医药企业的展厅“黑科技”",
          date: "2020-08-07",
          url: "https://mp.weixin.qq.com/s/ZD0Jzktqe-rSAOU4WD8i4w",
        },
        {
          textTwo: "广影国际影城 | 后疫情时代，看电影院如何进行数字化升级？",
          date: "2020-07-31",
          url: "https://mp.weixin.qq.com/s/GC217iMWz5YlwsSuQSLxJg",
        },
        {
          textTwo:
            "7月数拓快讯 | 茶百道、苏阁鲜茶、蔡林记、牛春来...多个项目落地",
          date: "2020-07-24",
          url: "https://mp.weixin.qq.com/s/8Yyj7UwVed37izbs6X8viA",
        },
        // ===================================
        {
          textTwo: "七欣天 | 门店数字化升级，首家已落地！",
          date: "2020-07-17",
          url: "https://mp.weixin.qq.com/s/nPZKxsmO7kGNmEk3rGQJgw",
        },
        {
          textTwo: "海底捞 | 数字化运营新模式，‘服务’与‘营销’的无缝融合！",
          date: "2020-07-17",
          url: "https://mp.weixin.qq.com/s/hhYSUjwyzVvi0_UxTwNIdw",
        },

        {
          textTwo:
            "6月数拓快讯 | 茶百道、东东包、魏家凉皮、盛香亭...多个项目落地",
          date: "2020-06-24",
          url: "https://mp.weixin.qq.com/s/tO-GfGTzluchdcNymCZP2Q",
        },
        {
          textTwo: "数拓拍了拍你，提醒你看一下“货架+智屏”这对当红cp！",
          date: "2020-06-22",
          url: "https://mp.weixin.qq.com/s/bKm8D82_UbZv4BfpOg1sJg",
        },
        {
          textTwo: "旺店大招牌 | 可联屏、会营销的数字餐牌！",
          date: "2020-06-19",
          url: "https://mp.weixin.qq.com/s/PUTHehzk3wZHk5MGS0WWmg",
        },
        {
          textTwo: "模板上新 | 端午送福利，又一波免费模板上新啦！",
          date: "2020-06-13",
          url: "https://mp.weixin.qq.com/s/K8Dr5s2_voeotUy0a2gN2A",
        },
        {
          textTwo: "数拓×平安 | 打造更智能的金融新空间",
          date: "2020-06-09",
          url: "https://mp.weixin.qq.com/s/CtBSBcP0GHhyqXg_rh8hxQ",
        },
        {
          textTwo: "提升销量的餐牌设计，从这三招入手",
          date: "2020-06-05",
          url: "https://mp.weixin.qq.com/s/U7Z8YVEEgsvUgvjdC2397A",
        },
        // =======================================================
        {
          textTwo: "盘点“品牌520营销”，进来抄作业！",
          date: "2020-05-29",
          url: "https://mp.weixin.qq.com/s/HjGW0GpC7k5W2_YgyOf4bg",
        },
        {
          textTwo: "设计方案 | 快餐店怎么设计？快学学这个汉堡工厂吧！",
          date: "2020-05-22",
          url: "https://mp.weixin.qq.com/s/qmv22jwVgRZ-IvAd8VKukg",
        },
        {
          textTwo:
            "5月数拓快讯 | 八马茶业、东方既白、都市甜心、兵之王...多个项目落地",
          date: "2020-05-21",
          url: "https://mp.weixin.qq.com/s/X-cXnW00bAV1I9MifXaKJg",
        },
        //  {
        //   textTwo: "数拓投屏小程序，5月15日上线！50元/年，首月免费！",
        //   date: "2020-05-15",
        //   url:
        //     "https://mp.weixin.qq.com/s/PfYppnTO1gqW73bQvuKhBQ"
        // },
        {
          textTwo: "总控域名迁移通知",
          date: "2020-05-09",
          url: "https://mp.weixin.qq.com/s/SEoNFLH-5Cuugf5DUNTjZw",
        },
        {
          textTwo: "设计方案 | 一看就让人口水直流！火锅店设计这样做！",
          date: "2020-05-08",
          url: "https://mp.weixin.qq.com/s/kQwatDtow_64gQ952sgKDA",
        },
        {
          textTwo: "干货 | 菜单才是盈利的关键？这份规划指南你一定要学！",
          date: "2020-04-30",
          url: "https://mp.weixin.qq.com/s/mmhjBVf8hSYFHmq4WEVPIg",
        },
        {
          textTwo: "设计方案 | 轻奢风茶饮店的视觉怎么设计？这样很“ins”！",
          date: "2020-04-30",
          url: "https://mp.weixin.qq.com/s/DHU4ze_-seNmjxnCY_VIUg",
        },
        {
          textTwo: "模板上新 | 这个五一，2条视频7类模板，全都免费打包送给你！",
          date: "2020-04-24",
          url: "https://mp.weixin.qq.com/s/C-I74sZ8DfyY2HqlccKpiA",
        },
        {
          textTwo:
            "降本 | 营销、运营、设计，成本高居不下？看数拓用1块大屏通通搞定！",
          date: "2020-04-17",
          url: "https://mp.weixin.qq.com/s/Sbjk4yn70S5LmDrccC4pcg",
        },
        {
          textTwo: "案例 | 中亿GR超跑俱乐部为你示范，购物中心怎么“装”出新鲜感",
          date: "2020-04-03",
          url: "https://mp.weixin.qq.com/s/GsRheXnaFI0Lr4HsztigIw",
        },
        // =======================================================================
        {
          textTwo: "案例 | 资本寒冬，钱大妈凭什么逆势而上？",
          date: "2020-03-27",
          url: "https://mp.weixin.qq.com/s/Q6kpdIlc9-EQ6fwj46p9uQ",
        },
        {
          textTwo: "曙光在望，从低成本靓店开启2020！",
          date: "2020-03-13",
          url: "https://mp.weixin.qq.com/s/d_Ajvag3-ftNh2B7jmJxSQ",
        },
        {
          textTwo: "防疫模板第二弹 | 预防病毒，人人都是小能手！",
          date: "2020-02-21",
          url: "https://mp.weixin.qq.com/s/cvp5G12-En6xCnGpnHKarQ",
        },
        // --------------------------
        {
          textTwo: "防疫模板 | 致敬，疫情中的最美逆行者！",
          date: "2020-02-14",
          url: "https://mp.weixin.qq.com/s/9VhYEnxWBJLh_qKB2EiPxQ",
        },
        {
          textTwo: "模板上新 | 数拓春年大礼包，免费大放送！",
          date: "2020-01-19",
          url: "https://mp.weixin.qq.com/s/7a6tfWazUBR01H3KgjAnFQ",
        },
        {
          textTwo: "案例 | 数拓助力万达，数字化营销，引爆春节档",
          date: "2020-01-18",
          url: "https://mp.weixin.qq.com/s/NXGI1rJGEA0yxPIJ6V85rQ",
        },
        {
          textTwo: "案例 | “网紫”一只酸奶牛，黑化了？",
          date: "2020-01-10",
          url: "https://mp.weixin.qq.com/s/yioCDz-NcUUD7jbox6SHtA",
        },
        {
          textTwo: "案例 | 鱼酷：“这么活，才够味”，数拓：“店这么装，才够酷",
          date: "2020-01-03",
          url: "https://mp.weixin.qq.com/s/Esaemp6knpq4rZQzv2BRmQ",
        },
        {
          textTwo: "“靓店、降本、引流、增销”，数拓数字化营销PAAS如何做到？",
          date: "2019-12-28",
          url: "https://mp.weixin.qq.com/s/dmReusecKOUnDhrdBhbvVw",
        },

        {
          textTwo: "免费模板 | 叮咚~ 圣诞新‘装’已抵达，开门收礼啦！",
          date: "2019-12-14",
          url: "https://mp.weixin.qq.com/s/xafyYDMQzB5SWPcRKUUx0w",
        },
        {
          textTwo: "最潮“科技焕新”指南",
          date: "2019-12-06",
          url: "https://mp.weixin.qq.com/s/XILItcAe_pz95f__KMHanw",
        },
        {
          textTwo: "冰雪奇缘2 | 超长联屏打造的梦幻冰雪世界，尽在万达！",
          date: "2019-11-29",
          url: "https://mp.weixin.qq.com/s/QwNTA8bBhkO5WnHm2VQUtQ",
        },
        {
          textTwo: "餐饮海报这样设计，创意又好玩！",
          date: "2019-11-22",
          url: "https://mp.weixin.qq.com/s/LhpepvwAFmDbMuBTF6BtXg",
        },

        {
          textTwo: "快餐 | 大趋势之数字餐牌",
          date: "2019-11-15",
          url: "https://mp.weixin.qq.com/s/1drd0UFEcpdMmnvpG_5oOw",
        },
        {
          textTwo: "模板体验包 | 低至2.5折，约等于不要钱！",
          date: "2019-11-08",
          url: "https://mp.weixin.qq.com/s/9KxJ93b3XGehIkE_97fJDw",
        },
        {
          textTwo: "模板上新 | 万圣来袭，轰趴不打烊！",
          date: "2019-10-31",
          url: "https://mp.weixin.qq.com/s/9r-5aK6n1BNDdZkcOMaNPw",
        },
        {
          textTwo: "新功能上线 餐饮模板智能推荐来啦！",
          date: "2019-10-25",
          url: "https://mp.weixin.qq.com/s/pqgsy_r7nfCG7sqtJ7OfHw",
        },
        {
          textTwo: "中信港通 | 梅山进口汽车物流产业园的数据化运营升级",
          date: "2019-10-18",
          url: "https://mp.weixin.qq.com/s/3UBWxC2NOWWSfTnIRk8Mkg",
        },
        {
          textTwo: "Dior、PRADA、三宅一生、VOGUE 如何玩？",
          date: "2019-10-11",
          url: "https://mp.weixin.qq.com/s/MZStZOvxBJ7QVkhiP91XSQ",
        },
        {
          textTwo: "盛香亭 门店即产品——新式热卤的升级之路",
          date: "2019-09-30",
          url: "https://mp.weixin.qq.com/s/BN2RLDJQru3c6NbMxiNd3g",
        },
        {
          textTwo: "Levi's 武汉 | 用“新”技术致敬“旧”牛仔",
          date: "2019-09-28",
          url: "https://mp.weixin.qq.com/s/PbYL91Jc7GUYV0HAP-s64w",
        },
        {
          textTwo:
            "9月数拓快讯 | 正新手摇茶、吉野家、厦门网红茶饮...多个项目落地",
          date: "2019-09-20",
          url: "https://mp.weixin.qq.com/s/PhuWD7ivJSDf9MFWXKyvGw",
        },

        {
          textTwo: "趣味、实用、便捷的中秋营销攻略，请查收",
          date: "2019-09-12",
          url: "https://mp.weixin.qq.com/s/aPQ_wswfsQbTctbdsaMK4A",
        },
        {
          textTwo: "长福宫 | 一家“不安分”的高级海鲜餐厅",
          date: "2019-09-06",
          url: "https://mp.weixin.qq.com/s/AU4NWT29ezpomsCg1A1XTQ",
        },
        {
          textTwo: "Levi's 香港 | “你以为我穿的只是条裤子？不，它是牛仔文化。",
          date: "2019-08-30",
          url: "https://mp.weixin.qq.com/s/gqnN7WCCoTCpgXyq-0HOcQ",
        },

        {
          textTwo: "节日扎堆，营销有心无力？数拓9款游戏帮你解决烦恼！",
          date: "2019-08-23",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484344&idx=1&sn=8ace62bb64224d1a2cb2404272080bac&chksm=e8e3373ddf94be2bfdda6341e33514a15560060e240bd72a55c1749d8a068695f66d280ff492&scene=38#wechat_redirect",
        },
        {
          textTwo: "智慧陈列货架，开启未来智慧生活！",
          date: "2019-08-16",

          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484321&idx=1&sn=943a7d67c9ff62138263185e890081aa&chksm=e8e33724df94be32217b29e83a1aeb540e45193ece6fa4980dc98cbdcb3fcfe5369b68e6aab8&scene=38#wechat_redirect",
        },
        {
          textTwo: "七夕 | 数拓，见证爱她的每一刻",
          date: "2019-08-07",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484314&idx=1&sn=5655a7195f77f0015cf6a4913cc641dd&chksm=e8e3371fdf94be09a770ee053ec18a643b8194917662e78cd3029faa5308c27d5380090ab02b&scene=38#wechat_redirect",
        },
        {
          textTwo: "门店“新”意满满活动不断？那就选择数拓吧！",
          date: "2019-08-02",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484310&idx=1&sn=2a4299b9f8678b741e86bfcf507fe1f5&chksm=e8e33713df94be0542d7e9d9395baf1f5f9ce40cd191e61441aa7ce159827f5b44247e10f7a8&scene=38#wechat_redirect",
        },
        {
          textTwo: "李维斯东京旗舰店 | 牛仔裤“鼻祖”的拼接新选择",
          date: "2019-07-26",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484305&idx=1&sn=913c621c553d3901f9a1cc617801c721&chksm=e8e33714df94be02087b83e8fad674a8751ef17cb1e2c3b78c78e54fc6853692e5ee3d3ba4f8&scene=38#wechat_redirect ",
        },
        {
          textTwo: "数拓商用模板服务，总有一款适合你！",
          date: "2019-07-19",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484300&idx=1&sn=984fb5e2914f5d3c17379b7ee512db40&chksm=e8e33709df94be1f99e8639a9a9c34340ed830f93badb52940ede92a1d45ba74c52292575c34&scene=38#wechat_redirect   ",
        },
        {
          textTwo: "模板上新 | 酷暑夏日，绵绵冰沙来袭！",
          date: "2019-07-13",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484295&idx=1&sn=e6a949622928418282d9f1cc0f4b97d5&chksm=e8e33702df94be143abe3fef8e811b9053e03575b4a2b6b5396635d6a875088b3d785f805148&scene=38#wechat_redirect ",
        },
        {
          textTwo: "资讯 | 中标！数拓拿下中国移动又一大单！",
          date: "2019-07-04",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484289&idx=1&sn=fe72677f22ed32c655f24f69145fea8a&chksm=e8e33704df94be12c28632e103958ba1886247fab919fef8251602a8868949024f42da634570&scene=38#wechat_redirect",
        },
        {
          textTwo: "案例 | 老乡鸡狂撒红包，安徽全省多屏联动，活动圆满成功！",
          date: "2019-07-02",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484279&idx=1&sn=adb4885d867f1a637297df24ddefec12&chksm=e8e337f2df94bee4aec4f915c339369a0fe6cdfc6e61e292290cef0a9ae4d69dc73b6519d193&scene=38#wechat_redirect",
        },
        {
          textTwo: "资讯 | 数拓受邀参加2019中国智慧新零售产业大会，并发表演讲",
          date: "2019-06-27",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484273&idx=1&sn=fb465e4fb6a8cdb57ac89ee3dd3ab3d8&chksm=e8e337f4df94bee22506c517ae1a3870f8992c8a90b4485de8e0792d718b67835e5c91717aaa&scene=38#wechat_redirect",
        },
        {
          textTwo:
            "资讯 | 数拓×中国移动，云货架新玩法亮相MWC2019，打造沉浸式3C卖场！",
          date: "2019-06-26",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484262&idx=1&sn=69540ee2d5ff40dd3b4496f6566209d3&chksm=e8e337e3df94bef5477a953bb3f3b1451b738bedebf418f99844256b4090720dd4b00bdbcc71&scene=38#wechat_redirect",
        },
        {
          textTwo: "新官网上线 | AI+赋能，开启线下商显未来",
          date: "2019-06-14",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484251&idx=1&sn=c0ec3bc77983edddd12797ed761fed81&chksm=e8e337dedf94bec827cc24d58dd5ac12e987e9ce52c9994a38ce4df49084565d3d60ab0be842&scene=38#wechat_redirect",
        },
        {
          textTwo: "模板上新 | 端午，粽享精彩！",
          date: "2019-06-06",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484246&idx=1&sn=d3966aa8f0afa4eca3f1f1c2661eed32&chksm=e8e337d3df94bec53036bbd7091c37ade30609017b1a282c1cddc062a902a977397cb3f7748e&scene=38#wechat_redirect",
        },
        {
          textTwo: "鱼酷 | 打造沉浸式用餐体验",
          date: "2019-06-01",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484239&idx=1&sn=864978f18216bd59c40d6e533d10f187&chksm=e8e337cadf94bedc3a906b5e9fb2db6163ecefde9b076ae8085c804603965cc2bc1945d42885&scene=38#wechat_redirect",
        },

        {
          textTwo: "模板上新 | 学习六一新魔法——旋转吧，饮料杯！",
          date: "2019-05-31",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484233&idx=1&sn=fe948d2e5989693a66deaaed8dafafdc&chksm=e8e337ccdf94beda5ab4c40a6d38d97d4eed2111cb26f4920a5da5b50c861dbc5ada9589f5b4&scene=38#wechat_redirect",
        },
        {
          textTwo:
            "资讯 | 数拓 x 华星光电，闪耀亮相2019 Smart Retail，刷新你的“视”界观！",
          date: "2019-05-24",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484214&idx=1&sn=c8eaf1923061a173c7cbd16c2faf67f5&chksm=e8e337b3df94bea53899d8732d77973be155c78f86feaba677fefad47d2d70cff86f628d61a6&scene=38#wechat_redirect",
        },
        {
          textTwo: "袁记肉夹馍 | 中式快餐品牌的餐牌升级 ",
          date: "2019-05-17",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484207&idx=1&sn=11737a2b546c263d4e5ac968e0aa9fd6&chksm=e8e337aadf94bebc2f6e866ee4948de7dc62500e0a98bfd21a2f7f5ddbba0c9cd652c6947fe9&scene=38#wechat_redirect",
        },
        {
          textTwo: "模板上新 | 我想在西瓜里游泳，仲夏夜里吃冰沙",
          date: "2019-05-10",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484203&idx=1&sn=2cf4af360d31844acd552ee79f99552e&chksm=e8e337aedf94beb853700177f565c858a0bacd84ba9bf954abe76cc7b5295b7d89083d3129d3&scene=38#wechat_redirect",
        },
        {
          textTwo: "星辰云货架 | 1块屏幕搞定7大运营难题",
          date: "2019-05-08",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484197&idx=1&sn=d83d43226a9133ad41a62dcbebaf3eb7&chksm=e8e337a0df94beb6850d72b1e1f439cca6ec3ff362b828ca944caebf861f5bbfac97bfc3466a&scene=38#wechat_redirect",
        },
        {
          textTwo: "中国移动×数拓科技 = 5G×新零售",
          date: " 2019-04-30",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484192&idx=1&sn=14e82ccfc962c5333b02abf74bea4168&chksm=e8e337a5df94beb3737145ed94079a4d1ceb27bc961158e786327b7d30058680ec58f51f7c9c&scene=38#wechat_redirect",
        },
        {
          textTwo: "模板上新 | 用这一抹香港霓虹，装点你的店铺吧！ ",
          date: "2019-04-26",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484187&idx=1&sn=8b47a5284e13808dfe4a9b275c7eabbd&chksm=e8e3379edf94be882406dfdf458e17339da73016b5d6edcb3fbaafce89ddbfaba3e89c2261fd&scene=38#wechat_redirect",
        },
        {
          textTwo: "平安×数拓 | 共同开启金融新零售时代",
          date: "2019-04-19",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484178&idx=1&sn=03ba063ccc57fffb00c9695abf3a0865&chksm=e8e33797df94be81c88ec145ce30be7709c11a136ea245873d88ffe5ab4aa6a0b02f453af9fa&scene=38#wechat_redirect",
        },
        {
          textTwo: "案例 · 小龙坎 | 广告+售卖，用智屏开启老火锅新体验 ",
          date: "2019-04-18",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484174&idx=1&sn=03ab84a9db5e9371853146887a884f68&chksm=e8e3378bdf94be9debf38d2035a982b0262d47c6a42cb0cfa97f4e2f8d61951075cefefee79c&scene=38#wechat_redirect",
        },
        {
          textTwo: "案例 | 数拓×The North Face，用户外精神，探索智慧零售！ ",
          date: "2019-04-12",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484166&idx=1&sn=34fac04742043971b44a46b92d77112f&chksm=e8e33783df94be95cb04440f58ee24051c807a18d4ee729ce90209d7f4174ed8918851a9758b&scene=38#wechat_redirect",
        },
        {
          textTwo: "资讯 | 数拓 · CITE2019 —— “传统商业显示在智能时代的新角色”",
          date: " 2019-04-10",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484161&idx=1&sn=e1d9f3b1643a1acb1e0c07dde254b813&chksm=e8e33784df94be92cdc477b53e32f96e92321b572f0726c1a0eacf6099035f0750d2b5ab055f&scene=38#wechat_redirect",
        },
        {
          textTwo: "数字餐牌，你选对了吗？  ",
          date: " 2019-03-28",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484147&idx=1&sn=41c4dae73b12989d7576852d09d98fcf&chksm=e8e33676df94bf605a272072d77eebaa5ccc51d883c23958e40291c820cbb3c71eb20eff649c&scene=38#wechat_redirect",
        },
        {
          textTwo: "今日春分",
          date: " 2019-03-21",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484139&idx=1&sn=c4429f844f6f40e6f77c85ca27dcf2e8&chksm=e8e3366edf94bf78ba62bf39d39f3a02d4c43899625ef38603b787793f883a9bb9fa7d037a6a&scene=38#wechat_redirect",
        },
        {
          textTwo: "模板上新 | 春日明媚，清新果茶联屏模板上架了！",
          date: "2019-03-20",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484136&idx=1&sn=bdc4f13ce8617b30d535406a39614eb8&chksm=e8e3366ddf94bf7b167e1a3e313f2e9b148b68bd35c63565355cc3b8bf5bdc55924677849b0b&scene=38#wechat_redirect",
        },
        {
          textTwo: "视界 | 别人家的智慧展厅都有什么黑科技？ ",
          date: "2019-03-15",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484129&idx=1&sn=8f3e9e7d1f27be535899d52f21ab9053&chksm=e8e33664df94bf7237ae26660d52038592f18c2d770502f3210eaa3a1af4fccd8f4f13ce2118&scene=38#wechat_redirect",
        },
        {
          textTwo: "贡茶草莓季 | 数字餐牌视效升级，带来快饮市场新机遇  ",
          date: "2019-03-06",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484124&idx=1&sn=74cc03f8c2dc0190716fd77344459a01&chksm=e8e33659df94bf4f854eedb23aba1315e83b07be6c051443a49338515f5aee51784243c21fbd&scene=38#wechat_redirect",
        },
        {
          textTwo: "数拓助力阿里快闪店，2月26日登陆香港！",
          date: "2019-03-01",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484114&idx=1&sn=d9eb164f74ff28ea60e760b2c1709da2&chksm=e8e33657df94bf41c08527a55187e367fafd4dc28b62f277bd0363834288a6eefe316276226a&scene=38#wechat_redirect",
        },
        {
          textTwo: "餐饮界网红常青树的秘密武器，已经被我们掌握了！",
          date: "2019-02-22",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484109&idx=1&sn=067cb6bd8a78bfa3b5e349bb09cdfa4a&chksm=e8e33648df94bf5e2fe487cc4d77718755f27681dbb870d1eac5d42a528c414e368b6763d76b&scene=38#wechat_redirect",
        },
        {
          textTwo: "新鲜出炉的放假通知，请查收！",
          date: "2019-02-01",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484104&idx=1&sn=773ccde00bbc6f4c084647f19393051c&chksm=e8e3364ddf94bf5befaaa734ee7669799106d25f82695dce143e4011396be943f37f409cbaf0&scene=38#wechat_redirect",
        },
        {
          textTwo: "快来看看，数拓的掌上明“猪”是你吗？",
          date: "2019-01-30",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484095&idx=1&sn=fc7ac79896352fcee9b1b82fc9016b94&chksm=e8e3363adf94bf2c2daefbf0e63ed4a67e7c51dca9235f152f3d343188a50d79ed25cce1f838&scene=38#wechat_redirect",
        },
        {
          textTwo: "数拓福利 | 答题赢好礼啦！",
          date: "2019-01-25",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484090&idx=1&sn=824d323f04666182a28d7466a6bbc1c7&chksm=e8e3363fdf94bf29fd15750b0b62c89712df2bb43ca9281547f1600912728829354c08ed215f&scene=38#wechat_redirect",
        },
        {
          textTwo: "数拓福利 | 答题赢好礼啦！",
          date: "2019-01-23",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484088&idx=1&sn=fc4a8418b2316a7113885f24f7acdde2&chksm=e8e3363ddf94bf2bc74eae179e072ad126d477923937e793c2a0c0ecd4040ba5ccdb220a3958&scene=38#wechat_redirect",
        },
        {
          textTwo: "数拓云拼接，玩转花式拼法，点亮商业空间！",
          date: "2019-01-18",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484072&idx=1&sn=322081fddf185a669b527172dd46efaf&chksm=e8e3362ddf94bf3bd67bf499a251f413a322b687b16bb265a0f2b2cb2da90d228001e633a26c&scene=38#wechat_redirect",
        },
        {
          textTwo: "历历相伴度佳节，温暖相伴腊八粥  ",
          date: "2019-01-13",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484048&idx=1&sn=5e61a1e10cf44ababd8c8d6301c724c8&chksm=e8e33615df94bf03b7f7b8f45458444f2f27be0b68c7159d35f79d4d5340f272f7c9aeebc9f3&scene=38#wechat_redirect",
        },
        {
          textTwo: "2019阿里ONE商业大会，新零售杰出生态伙伴到底是何方神圣？ ",
          date: "2019-01-12",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484044&idx=1&sn=f2248a3a645f1332cfedcef9122d6770&chksm=e8e33609df94bf1fff985bc7dfa2a42a784dede927ad6ed8d1260346bf4a6edd518b6c4b09a8&scene=38#wechat_redirect",
        },
        {
          textTwo: "店里还在用家用设备？数小拓喊你来了解投屏安全保护措施啦",
          date: "2019-01-08",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484034&idx=1&sn=914a4f35aa72df59a29fa82faaa371a1&chksm=e8e33607df94bf113d2099a6e4e4ce4fe643be79ab2e8a4c2dad68aa439036074484ada4b03d&scene=38#wechat_redirect",
        },
        {
          textTwo: "寒夜已来，新岁即至 ",
          date: "2019-01-05",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484016&idx=1&sn=62604ecf59177a8fb96803395c49aa36&chksm=e8e336f5df94bfe3d7c40315d14e3c510e9b5d0dfb46ed98b6c17d856655c36cd0ad1b7df9a2&scene=38#wechat_redirect",
        },
        {
          textTwo: "万达联屏新视效，超震撼，秘诀在这里！",
          date: "2019-01-04",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484017&idx=1&sn=a49ce5a22667c3d973523e20eba810e6&chksm=e8e336f4df94bfe22d6514a19a11530d3a522d92c786a55691458f1ce2d9a40853af763c71ed&scene=38#wechat_redirect",
        },
      ],
      inforArray2019: [
        {
          textTwo: "“靓店、降本、引流、增销”，数拓数字化营销PAAS如何做到？",
          date: "2019-12-28",
          url: "https://mp.weixin.qq.com/s/dmReusecKOUnDhrdBhbvVw",
        },

        {
          textTwo: "免费模板 | 叮咚~ 圣诞新‘装’已抵达，开门收礼啦！",
          date: "2019-12-14",
          url: "https://mp.weixin.qq.com/s/xafyYDMQzB5SWPcRKUUx0w",
        },
        {
          textTwo: "最潮“科技焕新”指南",
          date: "2019-12-06",
          url: "https://mp.weixin.qq.com/s/XILItcAe_pz95f__KMHanw",
        },
        {
          textTwo: "冰雪奇缘2 | 超长联屏打造的梦幻冰雪世界，尽在万达！",
          date: "2019-11-29",
          url: "https://mp.weixin.qq.com/s/QwNTA8bBhkO5WnHm2VQUtQ",
        },
        {
          textTwo: "餐饮海报这样设计，创意又好玩！",
          date: "2019-11-22",
          url: "https://mp.weixin.qq.com/s/LhpepvwAFmDbMuBTF6BtXg",
        },

        {
          textTwo: "快餐 | 大趋势之数字餐牌",
          date: "2019-11-15",
          url: "https://mp.weixin.qq.com/s/1drd0UFEcpdMmnvpG_5oOw",
        },
        {
          textTwo: "模板体验包 | 低至2.5折，约等于不要钱！",
          date: "2019-11-08",
          url: "https://mp.weixin.qq.com/s/9KxJ93b3XGehIkE_97fJDw",
        },
        {
          textTwo: "模板上新 | 万圣来袭，轰趴不打烊！",
          date: "2019-10-31",
          url: "https://mp.weixin.qq.com/s/9r-5aK6n1BNDdZkcOMaNPw",
        },
        {
          textTwo: "新功能上线 餐饮模板智能推荐来啦！",
          date: "2019-10-25",
          url: "https://mp.weixin.qq.com/s/pqgsy_r7nfCG7sqtJ7OfHw",
        },
        {
          textTwo: "中信港通 | 梅山进口汽车物流产业园的数据化运营升级",
          date: "2019-10-18",
          url: "https://mp.weixin.qq.com/s/3UBWxC2NOWWSfTnIRk8Mkg",
        },
        {
          textTwo: "Dior、PRADA、三宅一生、VOGUE 如何玩？",
          date: "2019-10-11",
          url: "https://mp.weixin.qq.com/s/MZStZOvxBJ7QVkhiP91XSQ",
        },
        {
          textTwo: "盛香亭 门店即产品——新式热卤的升级之路",
          date: "2019-09-30",
          url: "https://mp.weixin.qq.com/s/BN2RLDJQru3c6NbMxiNd3g",
        },
        {
          textTwo: "Levi's 武汉 | 用“新”技术致敬“旧”牛仔",
          date: "2019-09-28",
          url: "https://mp.weixin.qq.com/s/PbYL91Jc7GUYV0HAP-s64w",
        },
        {
          textTwo:
            "9月数拓快讯 | 正新手摇茶、吉野家、厦门网红茶饮...多个项目落地",
          date: "2019-09-20",
          url: "https://mp.weixin.qq.com/s/PhuWD7ivJSDf9MFWXKyvGw",
        },

        {
          textTwo: "趣味、实用、便捷的中秋营销攻略，请查收",
          date: "2019-09-12",
          url: "https://mp.weixin.qq.com/s/aPQ_wswfsQbTctbdsaMK4A",
        },
        {
          textTwo: "长福宫 | 一家“不安分”的高级海鲜餐厅",
          date: "2019-09-06",
          url: "https://mp.weixin.qq.com/s/AU4NWT29ezpomsCg1A1XTQ",
        },
        {
          textTwo: "Levi's 香港 | “你以为我穿的只是条裤子？不，它是牛仔文化。",
          date: "2019-08-30",
          url: "https://mp.weixin.qq.com/s/gqnN7WCCoTCpgXyq-0HOcQ",
        },

        {
          textTwo: "节日扎堆，营销有心无力？数拓9款游戏帮你解决烦恼！",
          date: "2019-08-23",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484344&idx=1&sn=8ace62bb64224d1a2cb2404272080bac&chksm=e8e3373ddf94be2bfdda6341e33514a15560060e240bd72a55c1749d8a068695f66d280ff492&scene=38#wechat_redirect",
        },
        {
          textTwo: "智慧陈列货架，开启未来智慧生活！",
          date: "2019-08-16",

          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484321&idx=1&sn=943a7d67c9ff62138263185e890081aa&chksm=e8e33724df94be32217b29e83a1aeb540e45193ece6fa4980dc98cbdcb3fcfe5369b68e6aab8&scene=38#wechat_redirect",
        },
        {
          textTwo: "七夕 | 数拓，见证爱她的每一刻",
          date: "2019-08-07",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484314&idx=1&sn=5655a7195f77f0015cf6a4913cc641dd&chksm=e8e3371fdf94be09a770ee053ec18a643b8194917662e78cd3029faa5308c27d5380090ab02b&scene=38#wechat_redirect",
        },
        {
          textTwo: "门店“新”意满满活动不断？那就选择数拓吧！",
          date: "2019-08-02",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484310&idx=1&sn=2a4299b9f8678b741e86bfcf507fe1f5&chksm=e8e33713df94be0542d7e9d9395baf1f5f9ce40cd191e61441aa7ce159827f5b44247e10f7a8&scene=38#wechat_redirect",
        },
        {
          textTwo: "李维斯东京旗舰店 | 牛仔裤“鼻祖”的拼接新选择",
          date: "2019-07-26",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484305&idx=1&sn=913c621c553d3901f9a1cc617801c721&chksm=e8e33714df94be02087b83e8fad674a8751ef17cb1e2c3b78c78e54fc6853692e5ee3d3ba4f8&scene=38#wechat_redirect ",
        },
        {
          textTwo: "数拓商用模板服务，总有一款适合你！",
          date: "2019-07-19",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484300&idx=1&sn=984fb5e2914f5d3c17379b7ee512db40&chksm=e8e33709df94be1f99e8639a9a9c34340ed830f93badb52940ede92a1d45ba74c52292575c34&scene=38#wechat_redirect   ",
        },
        {
          textTwo: "模板上新 | 酷暑夏日，绵绵冰沙来袭！",
          date: "2019-07-13",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484295&idx=1&sn=e6a949622928418282d9f1cc0f4b97d5&chksm=e8e33702df94be143abe3fef8e811b9053e03575b4a2b6b5396635d6a875088b3d785f805148&scene=38#wechat_redirect ",
        },
        {
          textTwo: "资讯 | 中标！数拓拿下中国移动又一大单！",
          date: "2019-07-04",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484289&idx=1&sn=fe72677f22ed32c655f24f69145fea8a&chksm=e8e33704df94be12c28632e103958ba1886247fab919fef8251602a8868949024f42da634570&scene=38#wechat_redirect",
        },
        {
          textTwo: "案例 | 老乡鸡狂撒红包，安徽全省多屏联动，活动圆满成功！",
          date: "2019-07-02",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484279&idx=1&sn=adb4885d867f1a637297df24ddefec12&chksm=e8e337f2df94bee4aec4f915c339369a0fe6cdfc6e61e292290cef0a9ae4d69dc73b6519d193&scene=38#wechat_redirect",
        },
        {
          textTwo: "资讯 | 数拓受邀参加2019中国智慧新零售产业大会，并发表演讲",
          date: "2019-06-27",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484273&idx=1&sn=fb465e4fb6a8cdb57ac89ee3dd3ab3d8&chksm=e8e337f4df94bee22506c517ae1a3870f8992c8a90b4485de8e0792d718b67835e5c91717aaa&scene=38#wechat_redirect",
        },
        {
          textTwo:
            "资讯 | 数拓×中国移动，云货架新玩法亮相MWC2019，打造沉浸式3C卖场！",
          date: "2019-06-26",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484262&idx=1&sn=69540ee2d5ff40dd3b4496f6566209d3&chksm=e8e337e3df94bef5477a953bb3f3b1451b738bedebf418f99844256b4090720dd4b00bdbcc71&scene=38#wechat_redirect",
        },
        {
          textTwo: "新官网上线 | AI+赋能，开启线下商显未来",
          date: "2019-06-14",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484251&idx=1&sn=c0ec3bc77983edddd12797ed761fed81&chksm=e8e337dedf94bec827cc24d58dd5ac12e987e9ce52c9994a38ce4df49084565d3d60ab0be842&scene=38#wechat_redirect",
        },
        {
          textTwo: "模板上新 | 端午，粽享精彩！",
          date: "2019-06-06",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484246&idx=1&sn=d3966aa8f0afa4eca3f1f1c2661eed32&chksm=e8e337d3df94bec53036bbd7091c37ade30609017b1a282c1cddc062a902a977397cb3f7748e&scene=38#wechat_redirect",
        },
        {
          textTwo: "鱼酷 | 打造沉浸式用餐体验",
          date: "2019-06-01",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484239&idx=1&sn=864978f18216bd59c40d6e533d10f187&chksm=e8e337cadf94bedc3a906b5e9fb2db6163ecefde9b076ae8085c804603965cc2bc1945d42885&scene=38#wechat_redirect",
        },

        {
          textTwo: "模板上新 | 学习六一新魔法——旋转吧，饮料杯！",
          date: "2019-05-31",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484233&idx=1&sn=fe948d2e5989693a66deaaed8dafafdc&chksm=e8e337ccdf94beda5ab4c40a6d38d97d4eed2111cb26f4920a5da5b50c861dbc5ada9589f5b4&scene=38#wechat_redirect",
        },
        {
          textTwo:
            "资讯 | 数拓 x 华星光电，闪耀亮相2019 Smart Retail，刷新你的“视”界观！",
          date: "2019-05-24",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484214&idx=1&sn=c8eaf1923061a173c7cbd16c2faf67f5&chksm=e8e337b3df94bea53899d8732d77973be155c78f86feaba677fefad47d2d70cff86f628d61a6&scene=38#wechat_redirect",
        },
        {
          textTwo: "袁记肉夹馍 | 中式快餐品牌的餐牌升级 ",
          date: "2019-05-17",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484207&idx=1&sn=11737a2b546c263d4e5ac968e0aa9fd6&chksm=e8e337aadf94bebc2f6e866ee4948de7dc62500e0a98bfd21a2f7f5ddbba0c9cd652c6947fe9&scene=38#wechat_redirect",
        },
        {
          textTwo: "模板上新 | 我想在西瓜里游泳，仲夏夜里吃冰沙",
          date: "2019-05-10",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484203&idx=1&sn=2cf4af360d31844acd552ee79f99552e&chksm=e8e337aedf94beb853700177f565c858a0bacd84ba9bf954abe76cc7b5295b7d89083d3129d3&scene=38#wechat_redirect",
        },
        {
          textTwo: "星辰云货架 | 1块屏幕搞定7大运营难题",
          date: "2019-05-08",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484197&idx=1&sn=d83d43226a9133ad41a62dcbebaf3eb7&chksm=e8e337a0df94beb6850d72b1e1f439cca6ec3ff362b828ca944caebf861f5bbfac97bfc3466a&scene=38#wechat_redirect",
        },
        {
          textTwo: "中国移动×数拓科技 = 5G×新零售",
          date: " 2019-04-30",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484192&idx=1&sn=14e82ccfc962c5333b02abf74bea4168&chksm=e8e337a5df94beb3737145ed94079a4d1ceb27bc961158e786327b7d30058680ec58f51f7c9c&scene=38#wechat_redirect",
        },
        {
          textTwo: "模板上新 | 用这一抹香港霓虹，装点你的店铺吧！ ",
          date: "2019-04-26",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484187&idx=1&sn=8b47a5284e13808dfe4a9b275c7eabbd&chksm=e8e3379edf94be882406dfdf458e17339da73016b5d6edcb3fbaafce89ddbfaba3e89c2261fd&scene=38#wechat_redirect",
        },
        {
          textTwo: "平安×数拓 | 共同开启金融新零售时代",
          date: "2019-04-19",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484178&idx=1&sn=03ba063ccc57fffb00c9695abf3a0865&chksm=e8e33797df94be81c88ec145ce30be7709c11a136ea245873d88ffe5ab4aa6a0b02f453af9fa&scene=38#wechat_redirect",
        },
        {
          textTwo: "案例 · 小龙坎 | 广告+售卖，用智屏开启老火锅新体验 ",
          date: "2019-04-18",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484174&idx=1&sn=03ab84a9db5e9371853146887a884f68&chksm=e8e3378bdf94be9debf38d2035a982b0262d47c6a42cb0cfa97f4e2f8d61951075cefefee79c&scene=38#wechat_redirect",
        },
        {
          textTwo: "案例 | 数拓×The North Face，用户外精神，探索智慧零售！ ",
          date: "2019-04-12",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484166&idx=1&sn=34fac04742043971b44a46b92d77112f&chksm=e8e33783df94be95cb04440f58ee24051c807a18d4ee729ce90209d7f4174ed8918851a9758b&scene=38#wechat_redirect",
        },
        {
          textTwo: "资讯 | 数拓 · CITE2019 —— “传统商业显示在智能时代的新角色”",
          date: " 2019-04-10",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484161&idx=1&sn=e1d9f3b1643a1acb1e0c07dde254b813&chksm=e8e33784df94be92cdc477b53e32f96e92321b572f0726c1a0eacf6099035f0750d2b5ab055f&scene=38#wechat_redirect",
        },
        {
          textTwo: "数字餐牌，你选对了吗？  ",
          date: " 2019-03-28",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484147&idx=1&sn=41c4dae73b12989d7576852d09d98fcf&chksm=e8e33676df94bf605a272072d77eebaa5ccc51d883c23958e40291c820cbb3c71eb20eff649c&scene=38#wechat_redirect",
        },
        {
          textTwo: "今日春分",
          date: " 2019-03-21",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484139&idx=1&sn=c4429f844f6f40e6f77c85ca27dcf2e8&chksm=e8e3366edf94bf78ba62bf39d39f3a02d4c43899625ef38603b787793f883a9bb9fa7d037a6a&scene=38#wechat_redirect",
        },
        {
          textTwo: "模板上新 | 春日明媚，清新果茶联屏模板上架了！",
          date: "2019-03-20",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484136&idx=1&sn=bdc4f13ce8617b30d535406a39614eb8&chksm=e8e3366ddf94bf7b167e1a3e313f2e9b148b68bd35c63565355cc3b8bf5bdc55924677849b0b&scene=38#wechat_redirect",
        },
        {
          textTwo: "视界 | 别人家的智慧展厅都有什么黑科技？ ",
          date: "2019-03-15",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484129&idx=1&sn=8f3e9e7d1f27be535899d52f21ab9053&chksm=e8e33664df94bf7237ae26660d52038592f18c2d770502f3210eaa3a1af4fccd8f4f13ce2118&scene=38#wechat_redirect",
        },
        {
          textTwo: "贡茶草莓季 | 数字餐牌视效升级，带来快饮市场新机遇  ",
          date: "2019-03-06",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484124&idx=1&sn=74cc03f8c2dc0190716fd77344459a01&chksm=e8e33659df94bf4f854eedb23aba1315e83b07be6c051443a49338515f5aee51784243c21fbd&scene=38#wechat_redirect",
        },
        {
          textTwo: "数拓助力阿里快闪店，2月26日登陆香港！",
          date: "2019-03-01",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484114&idx=1&sn=d9eb164f74ff28ea60e760b2c1709da2&chksm=e8e33657df94bf41c08527a55187e367fafd4dc28b62f277bd0363834288a6eefe316276226a&scene=38#wechat_redirect",
        },
        {
          textTwo: "餐饮界网红常青树的秘密武器，已经被我们掌握了！",
          date: "2019-02-22",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484109&idx=1&sn=067cb6bd8a78bfa3b5e349bb09cdfa4a&chksm=e8e33648df94bf5e2fe487cc4d77718755f27681dbb870d1eac5d42a528c414e368b6763d76b&scene=38#wechat_redirect",
        },
        {
          textTwo: "新鲜出炉的放假通知，请查收！",
          date: "2019-02-01",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484104&idx=1&sn=773ccde00bbc6f4c084647f19393051c&chksm=e8e3364ddf94bf5befaaa734ee7669799106d25f82695dce143e4011396be943f37f409cbaf0&scene=38#wechat_redirect",
        },
        {
          textTwo: "快来看看，数拓的掌上明“猪”是你吗？",
          date: "2019-01-30",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484095&idx=1&sn=fc7ac79896352fcee9b1b82fc9016b94&chksm=e8e3363adf94bf2c2daefbf0e63ed4a67e7c51dca9235f152f3d343188a50d79ed25cce1f838&scene=38#wechat_redirect",
        },
        {
          textTwo: "数拓福利 | 答题赢好礼啦！",
          date: "2019-01-25",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484090&idx=1&sn=824d323f04666182a28d7466a6bbc1c7&chksm=e8e3363fdf94bf29fd15750b0b62c89712df2bb43ca9281547f1600912728829354c08ed215f&scene=38#wechat_redirect",
        },
        {
          textTwo: "数拓福利 | 答题赢好礼啦！",
          date: "2019-01-23",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484088&idx=1&sn=fc4a8418b2316a7113885f24f7acdde2&chksm=e8e3363ddf94bf2bc74eae179e072ad126d477923937e793c2a0c0ecd4040ba5ccdb220a3958&scene=38#wechat_redirect",
        },
        {
          textTwo: "数拓云拼接，玩转花式拼法，点亮商业空间！",
          date: "2019-01-18",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484072&idx=1&sn=322081fddf185a669b527172dd46efaf&chksm=e8e3362ddf94bf3bd67bf499a251f413a322b687b16bb265a0f2b2cb2da90d228001e633a26c&scene=38#wechat_redirect",
        },
        {
          textTwo: "历历相伴度佳节，温暖相伴腊八粥  ",
          date: "2019-01-13",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484048&idx=1&sn=5e61a1e10cf44ababd8c8d6301c724c8&chksm=e8e33615df94bf03b7f7b8f45458444f2f27be0b68c7159d35f79d4d5340f272f7c9aeebc9f3&scene=38#wechat_redirect",
        },
        {
          textTwo: "2019阿里ONE商业大会，新零售杰出生态伙伴到底是何方神圣？ ",
          date: "2019-01-12",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484044&idx=1&sn=f2248a3a645f1332cfedcef9122d6770&chksm=e8e33609df94bf1fff985bc7dfa2a42a784dede927ad6ed8d1260346bf4a6edd518b6c4b09a8&scene=38#wechat_redirect",
        },
        {
          textTwo: "店里还在用家用设备？数小拓喊你来了解投屏安全保护措施啦",
          date: "2019-01-08",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484034&idx=1&sn=914a4f35aa72df59a29fa82faaa371a1&chksm=e8e33607df94bf113d2099a6e4e4ce4fe643be79ab2e8a4c2dad68aa439036074484ada4b03d&scene=38#wechat_redirect",
        },
        {
          textTwo: "寒夜已来，新岁即至 ",
          date: "2019-01-05",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484016&idx=1&sn=62604ecf59177a8fb96803395c49aa36&chksm=e8e336f5df94bfe3d7c40315d14e3c510e9b5d0dfb46ed98b6c17d856655c36cd0ad1b7df9a2&scene=38#wechat_redirect",
        },
        {
          textTwo: "万达联屏新视效，超震撼，秘诀在这里！",
          date: "2019-01-04",
          url:
            "https://mp.weixin.qq.com/s?__biz=MzIzNTc0MjY5OA==&mid=2247484017&idx=1&sn=a49ce5a22667c3d973523e20eba810e6&chksm=e8e336f4df94bfe22d6514a19a11530d3a522d92c786a55691458f1ce2d9a40853af763c71ed&scene=38#wechat_redirect",
        },
      ],
      inforArray2020: [
        {
          textTwo:
            "12月数拓快讯 | 茶颜悦色、茶百道、夸父、万象影城、另茶...多个项目落地",
          date: "2020-12-25",
          url: "https://mp.weixin.qq.com/s/IuNerACakudzB0Uc-s3NKQ",
        },
        {
          textTwo: "餐牌兼容叫号，低预算、中小体量门店叫号首选！",
          date: "2020-12-11",
          url: "https://mp.weixin.qq.com/s/wKD1UTSW4TYxdnAQ6-5Sbw",
        },
        {
          textTwo: "新瑞鹏宠物医疗集团 | 以关怀宠物为本的智慧门店升级",
          date: "2020-12-04",
          url: "https://mp.weixin.qq.com/s/_mD9LWH7_EEZNSd3Ybe7Ow",
        },
        {
          textTwo:
            "11月数拓快讯 | 池奈、超岛串串火锅、原来宝鸡、TipTop...多个项目落地",
          date: "2020-11-20",
          url: "https://mp.weixin.qq.com/s/G8GsWuCw4RB0cSB55v38ug",
        },
        {
          textTwo: "小芳茶卖部 | 洛阳新进网红的“靓店”之选",
          date: "2020-11-14",
          url: "https://mp.weixin.qq.com/s/slwUv9nX0iHylJYP712aSA",
        },
        // ===================
        {
          textTwo: "乔得一茶 | “连锁+加盟”模式下的数字化升级选择",
          date: "2020-10-16",
          url: "https://mp.weixin.qq.com/s/5MYGFF5Zvgbk2p-b-Xha8w",
        },
        {
          textTwo: "莱得快 | 网红景点门店的数字化升级",
          date: "2020-09-25",
          url: "https://mp.weixin.qq.com/s/M2ucZKklgXA1X2HrX-Ytgg",
        },
        {
          textTwo: "跨界营销 | 海底捞 X 三国志战略版，当火锅遇上游戏...",
          date: "2020-09-24",
          url: "https://mp.weixin.qq.com/s/L0muvratT_JjOrDi99jwJQ",
        },
        {
          textTwo:
            "9月数拓快讯 | 三郎米线、船歌鱼水饺、都市甜心、万达影城...多个项目落地",
          date: "2020-09-18",
          url: "https://mp.weixin.qq.com/s/1gZTefH2YU7tWr_XmOIsRg",
        },
        {
          textTwo: "小岳岳代言，老乡鸡全国战略布局要来了！",
          date: "2020-09-04",
          url: "https://mp.weixin.qq.com/s/vHgAWolhKwio5IFRV05--Q",
        },
        {
          textTwo:
            "8月数拓快讯 | 万达影院、一只酸奶牛、豆吉汤圆、贡茶...多个项目落地",
          date: "2020-08-22",
          url: "https://mp.weixin.qq.com/s/y_JJpqgMZbwmi1LiM98thg",
        },
        {
          textTwo: "中智药业 | 老牌上市医药企业的展厅“黑科技”",
          date: "2020-08-07",
          url: "https://mp.weixin.qq.com/s/ZD0Jzktqe-rSAOU4WD8i4w",
        },
        {
          textTwo: "广影国际影城 | 后疫情时代，看电影院如何进行数字化升级？",
          date: "2020-07-31",
          url: "https://mp.weixin.qq.com/s/GC217iMWz5YlwsSuQSLxJg",
        },
        {
          textTwo:
            "7月数拓快讯 | 茶百道、苏阁鲜茶、蔡林记、牛春来...多个项目落地",
          date: "2020-07-24",
          url: "https://mp.weixin.qq.com/s/8Yyj7UwVed37izbs6X8viA",
        },

        //  ====================================
        {
          textTwo: "七欣天 | 门店数字化升级，首家已落地！",
          date: "2020-07-17",
          url: "https://mp.weixin.qq.com/s/nPZKxsmO7kGNmEk3rGQJgw",
        },

        {
          textTwo: "海底捞 | 数字化运营新模式，‘服务’与‘营销’的无缝融合！",
          date: "2020-07-17",
          url: "https://mp.weixin.qq.com/s/hhYSUjwyzVvi0_UxTwNIdw",
        },

        {
          textTwo:
            "6月数拓快讯 | 茶百道、东东包、魏家凉皮、盛香亭...多个项目落地",
          date: "2020-06-24",
          url: "https://mp.weixin.qq.com/s/tO-GfGTzluchdcNymCZP2Q",
        },
        {
          textTwo: "数拓拍了拍你，提醒你看一下“货架+智屏”这对当红cp！",
          date: "2020-06-22",
          url: "https://mp.weixin.qq.com/s/bKm8D82_UbZv4BfpOg1sJg",
        },
        {
          textTwo: "旺店大招牌 | 可联屏、会营销的数字餐牌！",
          date: "2020-06-19",
          url: "https://mp.weixin.qq.com/s/PUTHehzk3wZHk5MGS0WWmg",
        },
        {
          textTwo: "模板上新 | 端午送福利，又一波免费模板上新啦！",
          date: "2020-06-13",
          url: "https://mp.weixin.qq.com/s/K8Dr5s2_voeotUy0a2gN2A",
        },
        {
          textTwo: "数拓×平安 | 打造更智能的金融新空间",
          date: "2020-06-09",
          url: "https://mp.weixin.qq.com/s/CtBSBcP0GHhyqXg_rh8hxQ",
        },
        {
          textTwo: "提升销量的餐牌设计，从这三招入手",
          date: "2020-06-05",
          url: "https://mp.weixin.qq.com/s/U7Z8YVEEgsvUgvjdC2397A",
        },
        {
          textTwo: "盘点“品牌520营销”，进来抄作业！",
          date: "2020-05-29",
          url: "https://mp.weixin.qq.com/s/HjGW0GpC7k5W2_YgyOf4bg",
        },
        {
          textTwo: "设计方案 | 快餐店怎么设计？快学学这个汉堡工厂吧！",
          date: "2020-05-22",
          url: "https://mp.weixin.qq.com/s/qmv22jwVgRZ-IvAd8VKukg",
        },
        {
          textTwo:
            "5月数拓快讯 | 八马茶业、东方既白、都市甜心、兵之王...多个项目落地",
          date: "2020-05-21",
          url: "https://mp.weixin.qq.com/s/X-cXnW00bAV1I9MifXaKJg",
        },
        //   {
        //   textTwo: "数拓投屏小程序，5月15日上线！50元/年，首月免费！",
        //   date: "2020-05-15",
        //   url:
        //     "https://mp.weixin.qq.com/s/PfYppnTO1gqW73bQvuKhBQ"
        // },
        {
          textTwo: "总控域名迁移通知",
          date: "2020-05-09",
          url: "https://mp.weixin.qq.com/s/SEoNFLH-5Cuugf5DUNTjZw",
        },
        {
          textTwo: "设计方案 | 一看就让人口水直流！火锅店设计这样做！",
          date: "2020-05-08",
          url: "https://mp.weixin.qq.com/s/kQwatDtow_64gQ952sgKDA",
        },
        {
          textTwo: "干货 | 菜单才是盈利的关键？这份规划指南你一定要学！",
          date: "2020-04-30",
          url: "https://mp.weixin.qq.com/s/mmhjBVf8hSYFHmq4WEVPIg",
        },
        {
          textTwo: "设计方案 | 轻奢风茶饮店的视觉怎么设计？这样很“ins”！",
          date: "2020-04-30",
          url: "https://mp.weixin.qq.com/s/DHU4ze_-seNmjxnCY_VIUg",
        },
        {
          textTwo: "模板上新 | 这个五一，2条视频7类模板，全都免费打包送给你！",
          date: "2020-04-24",
          url: "https://mp.weixin.qq.com/s/C-I74sZ8DfyY2HqlccKpiA",
        },
        {
          textTwo:
            "降本 | 营销、运营、设计，成本高居不下？看数拓用1块大屏通通搞定！",
          date: "2020-04-17",
          url: "https://mp.weixin.qq.com/s/Sbjk4yn70S5LmDrccC4pcg",
        },
        {
          textTwo: "案例 | 中亿GR超跑俱乐部为你示范，购物中心怎么“装”出新鲜感",
          date: "2020-04-03",
          url: "https://mp.weixin.qq.com/s/GsRheXnaFI0Lr4HsztigIw",
        },
        {
          textTwo: "案例 | 资本寒冬，钱大妈凭什么逆势而上？",
          date: "2020-03-27",
          url: "https://mp.weixin.qq.com/s/Q6kpdIlc9-EQ6fwj46p9uQ",
        },
        {
          textTwo: "曙光在望，从低成本靓店开启2020！",
          date: "2020-03-13",
          url: "https://mp.weixin.qq.com/s/d_Ajvag3-ftNh2B7jmJxSQ",
        },
        {
          textTwo: "防疫模板第二弹 | 预防病毒，人人都是小能手！",
          date: "2020-02-21",
          url: "https://mp.weixin.qq.com/s/cvp5G12-En6xCnGpnHKarQ",
        },
        // --------------------------
        {
          textTwo: "防疫模板 | 致敬，疫情中的最美逆行者！",
          date: "2020-02-14",
          url: "https://mp.weixin.qq.com/s/9VhYEnxWBJLh_qKB2EiPxQ",
        },
        {
          textTwo: "模板上新 | 数拓春年大礼包，免费大放送！",
          date: "2020-01-19",
          url: "https://mp.weixin.qq.com/s/7a6tfWazUBR01H3KgjAnFQ",
        },
        {
          textTwo: "案例 | 数拓助力万达，数字化营销，引爆春节档",
          date: "2020-01-18",
          url: "https://mp.weixin.qq.com/s/NXGI1rJGEA0yxPIJ6V85rQ",
        },
        {
          textTwo: "案例 | “网紫”一只酸奶牛，黑化了？",
          date: "2020-01-10",
          url: "https://mp.weixin.qq.com/s/yioCDz-NcUUD7jbox6SHtA",
        },
        {
          textTwo: "案例 | 鱼酷：“这么活，才够味”，数拓：“店这么装，才够酷",
          date: "2020-01-03",
          url: "https://mp.weixin.qq.com/s/Esaemp6knpq4rZQzv2BRmQ",
        },
      ],
      inforArray2021: [
        //  {
        //   textTwo: "超级鸡车 | 知名连锁炸鸡店的数字化升级",
        //   date: "2021-02-26",
        //   url: "https://mp.weixin.qq.com/s/8s_v5r4TEC3lPIbqyEBayg",
        // },
        {
          textTwo: "2020年度总结 | 案例盘点",
          date: "2021-01-29",
          url: "https://mp.weixin.qq.com/s/4XYbRxpMj3EaWwLMIDbzcg",
        },
        {
          textTwo: "1月数拓快讯 | 老乡鸡、钱大妈、船歌鱼水饺...多个项目落地",
          date: "2021-01-22",
          url: "https://mp.weixin.qq.com/s/NR2uoqkQpXDJVPkzW-iHMw",
        },
        {
          textTwo: "小龙坎 | 知名连锁火锅品牌的新升级",
          date: "2021-01-15",
          url: "https://mp.weixin.qq.com/s/IEPC5kjiHJbO58yBcYwWjQ",
        },
        {
          textTwo: "达味坊 | 美食广场的数字化升级",
          date: "2021-01-08",
          url: "https://mp.weixin.qq.com/s/3LGhay5lFsyRqEaM6fHi9Q"
        },
      ],
      tempArray: [],
    };
  },
  mounted() {
    this.tempArray = this.inforArray.slice(0, 14);
  },
  methods: {
    changSearch(val) {
      console.log(22222244444, val);
      if (val == "2020") {
        this.tempArray = [];
        this.inforArray = [];
        for (var j = 0; j < this.inforArray2020.length; j++) {
          this.tempArray.push(this.inforArray2020[j]);
          this.inforArray.push(this.inforArray2020[j]);
        }
        this.handleCurrentChange(1);
        console.log("2020202", this.tempArray);
        this.$forceUpdate();
      } else if (val == "2019") {
        this.tempArray = [];
        this.inforArray = [];
        for (var i = 0; i < this.inforArray2019.length; i++) {
          this.tempArray.push(this.inforArray2019[i]);
          this.inforArray.push(this.inforArray2019[i]);
        }
        this.handleCurrentChange(1);
        console.log("20192019", this.tempArray);
        this.$forceUpdate();
      } else if (val == "2021") {
        this.tempArray = [];
        this.inforArray = [];
        for (var i = 0; i < this.inforArray2021.length; i++) {
          this.tempArray.push(this.inforArray2021[i]);
          this.inforArray.push(this.inforArray2021[i]);
        }
        this.handleCurrentChange(1);
        console.log("20212021", this.tempArray);
        this.$forceUpdate();
      }
    },
    toLink(val) {
      let routeUrl = this.$router.resolve({
        path: `${val}`,
      });
      console.log(routeUrl.href);
      window.open(val, "_blank");
    },
    handleSizeChange(val) {
      this.pageSize = val;
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(11111111);
      console.log(Math.ceil(this.inforArray.length / 15));
      var tempPage = Math.ceil(this.inforArray.length / 15);
      for (var i = 1; i < tempPage; i++) {
        if (this.currentPage == i) {
          this.tempArray = this.inforArray.slice((i - 1) * 15, 15 * i - 1);
        }
      }
      if (this.currentPage == tempPage) {
        this.tempArray = this.inforArray.slice(
          (i - 1) * 15,
          this.inforArray.length
        );
      }
      // if (this.currentPage == 5) {
      //   console.log(this.inforArray);
      //   this.tempArray = this.inforArray.slice(60, this.inforArray.length);
      // }else if (this.currentPage == 4) {
      //   console.log(this.inforArray);
      //   this.tempArray = this.inforArray.slice(45, 59);
      // } else if (this.currentPage == 3) {
      //   console.log(this.inforArray);
      //   this.tempArray = this.inforArray.slice(30, 44);
      // } else if (this.currentPage == 2) {
      //   this.tempArray = this.inforArray.slice(15, 29);
      // } else if (this.currentPage == 1) {
      //   this.tempArray = this.inforArray.slice(0, 14);
      // }
    },
  },
};
</script>
<style scoped>
.topBox {
  height: 134px;
  background: #000;
}

.content {
  width: 70%;
  margin: auto;
  margin-top: 92px;
}

.floatBox::after {
  content: "";
  display: block;
  clear: both;
}

.floatLeft {
  width: 50%;
  float: left;
  font-size: 4rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 30px;
}

.floatRight {
  width: 50%;
  float: right;
  text-align: right;
}

.bottomLine {
  height: 1px;
  border-bottom: 1px solid rgba(0, 0, 0, 1);
  margin-top: 14px;
}

.bottomFloat::after {
  content: "";
  display: block;
  clear: both;
}

.bottomFloat {
  margin-top: 29px;
  font-size: 0;
  padding-right: 4%;
  background: #eee;
}
.bottomFloat:hover {
  cursor: pointer;
}
.bottomLeft {
  width: 26%;
  float: left;
}

.bottomLeft img {
  width: 100%;
  max-width: 449px;
}

.bottomRight {
  width: 71%;
  padding-left: 3%;
  float: right;
}

.rightFlex::after {
  content: "";
  display: block;
  clear: both;
}
.rightBoxLeft {
  width: 73%;
  float: left;
}
.rightBoxRight {
  width: 27%;
  float: right;
}
.rightBox {
  flex-grow: 1;
  font-size: 3rem;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 4%;
}

.textRight {
  text-align: right;
  font-size: 2.4rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 30px;
}

.rightText {
  font-size: 1.8rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  margin-top: 18px;
}

.boxContent {
  padding: 21px 36px 33px;
  border: 1px solid rgba(153, 153, 153, 1);
  margin-top: 28px;
}

.contentList {
  display: flex;
  margin-top: 32px;
}

.listBox {
  flex-grow: 1;
}

.textRightCss {
  text-align: right;
}

.textCssLeft {
  font-size: 2.4rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 31px;
}
.textCssLeft:hover {
  color: rgba(252, 200, 0, 1);
  cursor: pointer;
}
.textCssRight {
  font-size: 2.4rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 30px;
}

.pressCss {
  text-align: center;
  margin-top: 50px;
}

.listLineCss {
  width: 100%;
  height: 1px;
  border-bottom: 1px solid rgba(153, 153, 153, 1);
  margin-top: 27px;
}
</style>



// WEBPACK FOOTER //
// src/view/Information.vue